<template>
  <el-upload
    v-if="multiple"
    ref="upload"
    action="#"
    :on-error="uploadError"
    :show-file-list="false"
    multiple
    :auto-upload="false"
    :disabled="disabled"
    :class="{ upload_disabled: disabled }"
    :on-change="(file, fileList) => changeFileList(file, fileList)"
  >
    <span class="upload_btn" :class="showSvg ? '' : 'pd0'">
      <svg-icon v-if="showSvg" icon-class="upload" />
      <span class="name" :class="showSvg ? '' : 'pd0'">{{ btnName }}</span>
    </span>
  </el-upload>
  <el-upload
    v-else
    ref="upload"
    action="#"
    :headers="headers"
    :on-error="uploadError"
    :on-success="uploadSuccess"
    :show-file-list="false"
    :data="paramsData"
    :disabled="disabled"
    :auto-upload="false"
    :before-upload="beforeUpload"
    :class="{ upload_disabled: disabled }"
    :on-change="(file, fileList) => changeFileList(file, fileList)"
  >
    <span class="upload_btn" :class="showSvg ? '' : 'pd0'">
      <svg-icon v-if="showSvg" icon-class="upload" />
      <span class="name" :class="showSvg ? '' : 'pd0'">{{ btnName }}</span>
    </span>
  </el-upload>
</template>

<script>
  import store from '@/store'
  import { default as constants } from '@/config'
  import { saveAs } from 'file-saver'
  const { baseURL } = constants
  import { uploadBath } from '@/api/file'
  export default {
    name: 'VabUpload',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      btnName: {
        type: String,
        default: 'アップロード',
      },
      uploadUrl: {
        type: String,
        default: '',
      },
      batchUrl: {
        type: String,
        default: '',
      },
      paramsData: {
        type: Object,
        default: () => {},
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      showSvg: {
        type: Boolean,
        default: true,
      },
      initBefore: {
        type: Boolean,
        default: false,
      },
      actionItem: {
        type: Object,
        default: () => {},
      },
      errorExport: {
        type: Boolean,
        default: false,
      },
      // アップロードされたファイルはエクセルですか
      isExcel: {
        type: Boolean,
        default: false,
      },
      suTs: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        uploadActionUrl: baseURL + this.uploadUrl,
        fileList: [],
        loadingInstance: null,
      }
    },
    computed: {
      headers() {
        return {
          Authorization: `Bearer ${store.getters['user/token']}`,
        }
      },
    },
    watch: {
      fileList(val) {
        this.$refs.upload.clearFiles()
        if (this.multiple) {
          setTimeout(() => {
            if (val.length) {
              this.uploadAll()
            }
          }, 300)
        } else {
          val && val.length && this.upload()
        }
      },
    },
    methods: {
      changeFileList(file, fileList) {
        if (this.checkEfile(fileList)) return
        this.fileList = fileList
        if (this.isExcel) {
          var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
          const extension = ['xls', 'xlsx'].includes(testmsg)
          if (!extension) {
            this.msgInfo(
              this.$t(`validateMessage.${this.$messageCode.I00000468.name}`)
            )
            this.fileList = []
          }
        }
      },
      reset() {
        this.file = null
        this.fileList = null
        this.$refs.upload.clearFiles()
      },
      async uploadAll() {
        const FILE_SIZE_M = 10 * 1024 * 1024
        let fileList = []
        let checkFileSize = false
        this.fileList.filter((row) => {
          if (row.size > FILE_SIZE_M) {
            checkFileSize = true
          } else {
            fileList.push(row)
          }
        })
        if (checkFileSize) {
          if (fileList.length > 0) {
            this.msgInfo(
              this.format(
                this.$t(`validateMessage.${this.$messageCode.E00000515.name}`),
                '10MB'
              )
            )
          } else {
            this.msgError(
              this.format(
                this.$t(`validateMessage.${this.$messageCode.E00000515.name}`),
                '10MB'
              )
            )
            return
          }
        }
        const loadingInstance = this.$baseColorfullLoading()
        try {
          let formData = new FormData()
          if (this.paramsData?.buildingCd) {
            formData.append('buildingCd', this.paramsData.buildingCd)
          }
          if (this.paramsData?.reportNo) {
            formData.append('reportNo', this.paramsData.reportNo)
          }
          this.fileList.forEach((file) => {
            formData.append('files', file.raw) //ファイル
          })
          const res = await uploadBath(`${this.batchUrl}`, formData)
          loadingInstance.close()
          if (res) {
            this.$emit('on-success-bath', res)
          }
        } catch (error) {
          loadingInstance.close()
        }
      },
      async upload() {
        if (!this.checkfileSize(this.fileList)) {
          return
        }
        this.$baseColorfullLoading()
        try {
          let formData = new FormData()
          this.fileList.forEach((file) => {
            formData.append('file', file.raw) //ファイル
          })
          if (!this.$baseLodash.isUndefined(this.paramsData)) {
            Object.keys(this.paramsData).filter((item) => {
              formData.append(item, this.paramsData[item])
            })
          }
          let res = await uploadBath(`${this.uploadUrl}`, formData)
          this.$emit('on-success', res, this.actionItem, this.fileList)
          if (res && this.errorExport) {
            this.msgInfo(
              this.$t(`validateMessage.${this.$messageCode.I00000403.name}`)
            )
            let blob = res
            if (this.$baseLodash.has(res, 'data')) {
              blob = new Blob([res.data])
            }
            saveAs(blob, decodeURI(res.filename || res.fileName))
          } else {
            if (this.suTs && res) {
              this.msgSuccess(
                this.$t(`validateMessage.${this.$messageCode.I00000429.name}`)
              )
            }
          }
        } finally {
          this.fileList = []
          this.$baseColorfullLoading().close()
        }
      },
      beforeUpload(file) {
        this.loadingInstance = this.$baseColorfullLoading()
        if (this.isExcel) {
          var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
          const extension = ['xls', 'xlsx'].includes(testmsg)
          if (!extension) {
            this.msgInfo(
              this.$t(`validateMessage.${this.$messageCode.I00000468.name}`)
            )
            this.loadingInstance.close()
          }
          return extension
        }
      },
      uploadSuccess(response, fileList) {
        this.loadingInstance && this.loadingInstance.close()
        this.$emit('on-success', response, this.actionItem, fileList)
        // this.$baseEventBus.$emit('uscs')
        if (response && this.errorExport) {
          this.msgInfo(
            this.$t(`validateMessage.${this.$messageCode.I00000403.name}`)
          )
          const result = new Blob([response], {
            type: 'text/plain;charset=utf-8',
          })
          saveAs(result, `インポートエラー.txt`)
        } else {
          if (this.suTs && response) {
            this.msgSuccess(
              this.$t(`validateMessage.${this.$messageCode.I00000429.name}`)
            )
          }
        }
      },
      uploadError(err) {
        this.loadingInstance && this.loadingInstance.close()
        const result = JSON.parse(err.message)
        this.$baseNotify(result.errors[0].message, null, 'error')
      },
      uploadFile() {
        let dom = this.$refs['upload'].$children[0].$refs.input
        dom.click(function (event) {
          event.stopPropagation()
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/vab/styles/reportRc.scss';
</style>
<style lang="scss" scoped>
  .file_box_new .header_box .upload_disabled .upload_btn {
    background: #efefef;
    color: #a1a1a1;
    cursor: default;
    .svg-icon {
      color: #a1a1a1;
    }
  }
  .file_box_new .header_box .upload_disabled .upload_btn:hover {
    background: #efefef;
    color: #a1a1a1;
    cursor: default;
    .svg-icon {
      color: #a1a1a1;
    }
  }
  .el-button--small {
    padding: 0 !important;
    span.name {
      margin-left: 0 !important;
    }
  }
</style>
